export default {
  phone: /^1[0-9]{10}$/, // 手机号,1开头的11位数字
  username: /^[a-zA-Z0-9_@.]{4,25}$/, // 用户名,4~25位字符，只能包含英文字母、数字、@、点、下划线
  password: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/,//6~20位,不能为纯数字或者纯字母
};
